<template>
  <div class="image-grid">
    <template v-for="item in items">
      <div :key="item[keyID]" class="grid-item" @click="itemClick(item)">
        <div class="image-wrap">
          <div :style="getItemStyle(item)"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      default: function() {
        return [];
      }
    },
    keyID: {
      default: "id"
    },
    keyTitle: {
      default: "title"
    },
    keyURL: {
      default: "url"
    },
    title: {
      default: ""
    },
    ratio: {
      default: function() {
        return { w: 16, h: 9 };
      }
    },
    columns: {
      default: 4
    }
  },
  methods: {
    itemClick(item) {
      this.$emit("select", item.url);
    },
    getItemStyle(el) {
      let bg = el[this.keyURL];
      return {
        backgroundImage: "url(" + bg + ")",
        backgroundSize: "contain",
        paddingTop: "90%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  grid-gap: 5px;
}

.image-wrap {
  padding: 10px;
  margin: 10px 0;
}
.grid-item {
  background: #111;
  .meta {
    background: black;
    padding: 10px;
    p {
      margin: 0;
    }
  }
}
</style>

